import { devConsole } from '~/common/devConsole'

export default defineNuxtPlugin((nuxtApp) => {
  // 청크 로딩 에러 훅
  nuxtApp.hook('app:chunkError', ({ error }) => {
    devConsole.error('[Chunk Error] 청크 로딩 실패:', error)

    // 프로덕션 환경에서만 자동 리로드
    // automatic-immediate 설정이 이미 처리하므로 추가 로직은 로깅용
    if (import.meta.env.VITE_ENV === 'PROD') {
      devConsole.log('[Chunk Error] 페이지를 새로고침합니다...')
      // automatic-immediate가 자동으로 처리함
    }
  })

  // 전역 에러 핸들러 - 예상치 못한 청크 에러 캐치
  if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', (event) => {
      const errorMessage = event.reason?.message || ''

      // 동적 import 모듈 에러 감지
      if (errorMessage.includes('Failed to fetch dynamically imported module') ||
          errorMessage.includes('Loading chunk') ||
          errorMessage.includes('ChunkLoadError')) {

        devConsole.error('[Unhandled Chunk Error]', errorMessage)
        event.preventDefault() // 기본 에러 처리 방지

        // 프로덕션에서만 리로드 (automatic-immediate가 처리 못한 경우)
        if (import.meta.env.VITE_ENV === 'PROD') {
          // 약간의 지연을 두고 리로드 (무한 리로드 방지)
          setTimeout(() => {
            window.location.reload()
          }, 100)
        }
      }
    })

    // 네트워크 에러로 인한 청크 로딩 실패 감지
    window.addEventListener('error', (event) => {
      const target = event.target as HTMLScriptElement | HTMLLinkElement

      if (target && (target.tagName === 'SCRIPT' || target.tagName === 'LINK')) {
        const src = (target as HTMLScriptElement).src || (target as HTMLLinkElement).href

        if (src && src.includes('/_nuxt/')) {
          devConsole.error('[Resource Load Error] Nuxt 리소스 로딩 실패:', src)

          // 프로덕션에서 청크 파일 로딩 실패 시
          if (import.meta.env.VITE_ENV === 'PROD') {
            event.preventDefault()

            // 리로드 전에 짧은 지연
            setTimeout(() => {
              window.location.reload()
            }, 100)
          }
        }
      }
    }, true) // capture phase에서 이벤트 처리
  }
})